import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Streams from '../components/Streams';
import Timeline from '../components/Timeline';
import Benefits from '../components/Benefits';
import EnrollmentForm from '../components/EnrollmentForm';
import Footer from '../components/Footer';
import './LandingPage.css';

const LandingPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [recentEnrollment, setRecentEnrollment] = useState(null);
  const [showFloatingButton, setShowFloatingButton] = useState(true);
  const footerRef = useRef(null);

  const handleEnrollClick = () => {
    setIsFormOpen(true);
  };

  const handleEnrollSuccess = (enrollmentData) => {
    setRecentEnrollment(enrollmentData);
  };

  useEffect(() => {
    const checkFooterVisibility = () => {
      if (footerRef.current) {
        const footerRect = footerRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        setShowFloatingButton(footerRect.top > windowHeight);
      }
    };

    checkFooterVisibility();
    window.addEventListener('scroll', checkFooterVisibility);
    
    return () => {
      window.removeEventListener('scroll', checkFooterVisibility);
    };
  }, []);

  return (
    <>
      {/* Add SEO Rich Snippet */}
      <div itemScope itemType="https://schema.org/EducationalOrganization" style={{display: 'none'}}>
        <meta itemProp="name" content="DYLORA Internship Program" />
        <meta itemProp="description" content="Professional 1+1 Internship Program offering comprehensive training and hands-on internship experience" />
        <meta itemProp="url" content="https://intern.dylora.in" />
        <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
          <meta itemProp="addressLocality" content="Mumbai" />
          <meta itemProp="addressRegion" content="Maharashtra" />
          <meta itemProp="addressCountry" content="India" />
        </div>
        <meta itemProp="telephone" content="+91-70212-88082" />
        <meta itemProp="email" content="contact@dylora.in" />
        <meta itemProp="priceRange" content="₹599" />
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="landing-page"
      >
        <Header onEnrollClick={handleEnrollClick} />
        
        <Hero onEnrollClick={handleEnrollClick} />
        
        <Features />
        
        <Streams />
        
        <Timeline />
        
        <Benefits />
        
        <div ref={footerRef}>
          <Footer />
        </div>

        <EnrollmentForm
          isOpen={isFormOpen}
          onClose={() => setIsFormOpen(false)}
          onEnrollSuccess={handleEnrollSuccess}
        />

        {showFloatingButton && (
          <motion.button
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.3 }}
            onClick={handleEnrollClick}
            className="floating-enroll-button black-btn"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            aria-label="Enroll in DYLORA Internship Program for ₹599"
          >
            Enroll Now @ ₹599
          </motion.button>
        )}
      </motion.div>
    </>
  );
};

export default LandingPage;